import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled.div`
  font-family: 'AvenirNext';
  font-size: 12px;
  color: #3b3b3b;
  text-align: left;
  margin-right: 10px;
`;

export const ExValue = styled.b`
  display: inline-block;
  margin-left: 10px;
`;

export default {
  Panel: {},
  Row: {
    margin: '0 -10px 10px'
  },
  Col: {
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center'
  },
  ResetButton: {
    minWidth: 70
  }
}
